// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mWvQ_","right":"styles_right__2teU6"};